<template>
  <div>
    <header-slot>
      <template v-slot:content-right>
        <!-- Create Vehicles -->
        <b-button
          v-if="selectedCard == 'vehicles'"
          variant="outline-primary"
          @click="$refs.routesTable.addVehicle()"
        >
          {{ $t("Add vehicle").toUpperCase() }}
        </b-button>

        <!-- Creaite Vehicle type -->
        <b-button
          v-if="selectedCard == 'types'"
          variant="outline-primary"
          @click="$refs.routesTable.addVehicleType()"
        >
          {{ $t("Add type").toUpperCase() }}
        </b-button>

        <!-- Creates Brands -->
        <b-button
          v-if="selectedCard == 'brands_models'"
          variant="outline-primary"
          @click="$refs.routesTable.addBrand()"
        >
          {{ $t("Add brand").toUpperCase() }}
        </b-button>
      </template>
    </header-slot>
    <b-card
      no-body
      @changeSelectedCard="changeSelectedCard"
      class="border-top-primary border-3 border-table-radius px-0"
    >
      <router-view ref="routesTable" :key="routeName" />
    </b-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedCard: "vehicles",
    };
  },
  computed: {
    tabs() {
      return this.$route.matched[1].meta.tabs;
    },
    currentTab() {
      return this.$route.meta.tab;
    },
    routeName() {
      return this.$route.name;
    },
  },
  methods: {
    changeSelectedCard(card) {
      this.selectedCard = card;
    },
  },
};
</script>